module.exports = __webpack_public_path__ + "img/message-templates-icon-orange.4d35c447.svg";